import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Component, Input } from '@angular/core';

import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ApiLotsService } from 'src/app/services/api/api-lots.service';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { IDialogConfirm, DialogTypeEnum } from '../../../../../models/dialog';
import { IContractByNumberFormData } from 'src/app/models/contract';
import { IContractLot } from 'src/app/models/generic';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { ContractUtils } from 'src/app/shared/utils/contract.util';

@Component({
  selector: 'app-contract-card-dialog',
  templateUrl: './contract-card-dialog.component.html',
  styleUrls: ['./contract-card-dialog.component.scss']
})
export class ContractCardDialogComponent {
  @Input() contractList: IContractLot[] = [];
  @Input() originalContractIds: string[] = [];

  constructor(
    private _dialog: MatDialog,
    private _dialogService: ApiDialogService,
    private _lotsService: ApiLotsService,
    private _contractService: ApiContractService,
    private _snackbarService: SnackbarService
  ) {}

  openDetailsDialog(contract: IContractLot) {
    const data: IContractByNumberFormData = {
      Number: contract.Number,
      Contract: contract
    };

    this._dialogService.openContractDetailsDialog(data).then((response) => {});
  }

  deleteContract(contract: IContractLot): void {
    const isOriginalContract = this.isOriginalContract(contract.ContractId);

    if (isOriginalContract) {
      this.showRemoveOrCancelDialog(contract);
    } else {
      this.removeAddedContractFromList(contract);
    }
  }

  private isOriginalContract(contractId: string): boolean {
    return this.originalContractIds.includes(contractId);
  }

  private showRemoveOrCancelDialog(contract: IContractLot): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        title:
          `<div style="text-align: left;">
               <strong>Retirar do lote</strong> = contrato irá para tela de apuração ou
               <br /><strong>Cancelar contrato</strong> = status do contrato será cancelado e removido do lote.
               <br />Como deseja prosseguir?
           </div>`,

        boldTitle: `Contrato N°: ${contract.Number}`,
        confirm: 'Retirar',
        dismiss: 'Cancelar',
        dismissClass: 'btn-confirm'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response === true) {
        this.removeContractFromBatch(contract);
      } else if (response === false) {
        this.cancelContractStatus(contract);
      }
    });
  }

  private removeAddedContractFromList(contract: IContractLot): void {
    const indexContract = this.contractList.indexOf(contract);
    if (indexContract >= 0) {
      this.contractList.splice(indexContract, 1);
      ContractUtils.addRemovedContract(contract.ContractId);
      this._snackbarService.openSnackBar(
        `Contrato N°: ${contract.Number} removido do lote.`,
        SnackbarType.Success
      );
    }
  }

  private removeContractFromBatch(contract: IContractLot): void {
    const indexContract = this.contractList.indexOf(contract);
    if (indexContract >= 0) {
      this.contractList.splice(indexContract, 1);
      ContractUtils.addExcludedContract(contract.ContractId);
      this._snackbarService.openSnackBar(
        `Contrato N°: ${contract.Number} será apenas retirado do lote.`,
        SnackbarType.Success
      );
    }
  }

  private cancelContractStatus(contract: IContractLot): void {
    const indexContract = this.contractList.indexOf(contract);
    if (indexContract >= 0) {
      this.contractList.splice(indexContract, 1);
      ContractUtils.addCancelledContract(contract.ContractId);
      this._snackbarService.openSnackBar(
        `Status do contrato Nº ${contract.Number} será alterado para cancelado!`,
        SnackbarType.Success
      );
    }
  }
}
